import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFaceSurprise } from '@fortawesome/pro-light-svg-icons';
import MssTooltip from './MssTooltip';

function MssApiError({ id, widgetName, errorMessage, reloadMessage, isPage, reload }) {
  const plainWidgetName = Array.isArray(widgetName) ? widgetName.join('') : widgetName;
  const message = errorMessage || "Oops! It looks like we can't get the data right now.";
  const reloadMessageText = reloadMessage ? ` ${reloadMessage}` : '.';

  return (
    <Box id={`${id}_box`} sx={{ textAlign: 'center' }}>
      <FontAwesomeIcon id={`${id}_icon_surpriseFace`} icon={faFaceSurprise} size="lg" />
      &nbsp;
      <Typography id={`${id}_text_errorText`} variant="small">
        {message}&nbsp;
      </Typography>
      <MssTooltip id={`${id}_tooltip_link`} title={`Reload ${isPage ? 'page' : 'widget'}`}>
        <span>
          <Typography id={`${id}_text_errorText`} variant="small" component="span">
            Try loading &nbsp;
          </Typography>
          <Link
            component="button"
            type="button"
            variant="small"
            onClick={reload}
            underline="always"
            color="inherit"
            id={`error_message_reload_link_${plainWidgetName}`}
            sx={{ cursor: 'pointer' }}
            aria-label={`Reload ${plainWidgetName}`}
          >
            {plainWidgetName}
          </Link>
          <Typography id={`${id}_text_errorText`} variant="small" component="span">
            &nbsp;again later{reloadMessageText}
          </Typography>
        </span>
      </MssTooltip>
    </Box>
  );
}

export default MssApiError;
